import { UntypedFormGroup, UntypedFormBuilder, Validators, FormGroup} from '@angular/forms';
import { Router } from '@angular/router'; 
import { MatSnackBar } from '@angular/material/snack-bar';
import { matchingPasswords, emailValidator } from 'src/app/theme/utils/app-validators';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, Injectable, OnInit, TestabilityRegistry } from '@angular/core';
import { UserServiceService } from 'src/app/services/user-service.service';
import { ToastrService } from 'ngx-toastr';

import { EmailService } from 'src/app/services/Email.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-registerPro',
  templateUrl: './registerPro.component.html',
  styleUrls: ['./registerPro.component.scss']
})

  
@Injectable({
  providedIn: 'root'
})

export class RegisterProComponent implements OnInit {
    isAccept = false; 

  public registerProForm : FormGroup | any;
  public bgImage:any;

 // phonePattern = "^((\\+237-?)|(\\+33-?)|(\\+221-?))[8|9|6|7][0-9]{8}$";
   //indicatif France et Dom Tom 262,689,687,681,508,269,594,596,590,33
   phonePattern = "^((\\+262-?)|(\\+689-?)|(\\+687-?)|(\\+681-?)|(\\+508-?)|(\\+269-?)|(\\+594-?)|(\\+596-?)|(\\+590-?)|(\\+33-?))[8|9|6|7][0-9]{8}$";


constructor(public fb: UntypedFormBuilder,private toastr: ToastrService,
            public EmailServices:EmailService, public router:Router, 
            public service:UserServiceService, public snackBar: MatSnackBar, 
            private sanitizer:DomSanitizer, private spinner: NgxSpinnerService) { }


  ngOnInit() {

    this.bgImage = this.sanitizer.bypassSecurityTrustStyle('url(assets/images/others/entreprise.jpg)');
  
    this.initForm();

  }

  initForm() {

    this.registerProForm = this.fb.group({ 
      entreprise_name: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      email: ['', Validators.compose([Validators.required, emailValidator])],      
      entreprise_city: ['', Validators.required],
      location_nbr: ['', Validators.required],
      user_name: ['', Validators.required],
      user_phone: ['',  [Validators.required, Validators.pattern(this.phonePattern)]],
      receiveNewsletter:[ 'false',Validators.required ]                           
    });

  }

  public onregisterProFormSubmit():void {

    if(this.registerProForm.valid) {

      this.spinner.show();

      this.service.storeEntreprise(this.registerProForm.value).subscribe((data:any)=>{
           
        if(data.status) {

          this.toastr.success('Votre message a été envoyé avec succès ');
   
          this.spinner.hide();

          this.router.navigateByUrl('/').then();

        } else {

          this.toastr.error('Une erreur est survenue lors de l\'envoi du message. Veuillez réessayer ultérieurement');

        }
       

      },(error:any) => {
        
        this.toastr.error(error);
    
        throw error;

      });

    }

  }

}
